import React, { useState } from "react";

import { tileStyle } from "./sceneThumbs";

// fills a positioned, overflow-hidden box of the tile's shape
const BASE = { position: "absolute", maxWidth: "none", maxHeight: "none", objectFit: "fill", borderRadius: 0 };

/**
 * A tile {src, tile} of a sprite sheet: the whole sheet, scaled and moved so the box shows the tile. Hidden until the
 * sheet loads, as it is placed by its loaded size.
 */
export default function TileImg({ thumb }) {
  const [sheet, setSheet] = useState(null); // {src, size: [width, height]}
  const size = sheet && sheet.src === thumb.src ? sheet.size : null;
  return (
    <img
      src={thumb.src}
      alt=""
      style={size ? { ...BASE, ...tileStyle(thumb.tile, size) } : { ...BASE, visibility: "hidden" }}
      onLoad={(e) => setSheet({ src: thumb.src, size: [e.target.naturalWidth, e.target.naturalHeight] })}
    />
  );
}
